// The current application coordinates were pre-registered in a B2C tenant.
export const apiConfig = {
  b2cScopes: ['https://solumb2c.onmicrosoft.com/api/demo.read'],
  webApi: 'http://localhost:5000/hello'
}
